var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container HomeDetail"},[(_vm.type == 1)?_c('FunReportDetail'):_vm._e(),(_vm.type == 2)?_c('ProfessionalReportDetail'):_vm._e(),(_vm.type == 3)?_c('TreeReportDetail'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }